
// src/pages/ArticleDetails.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Container, CardMedia, Button } from '@mui/material';
import cardData from './data/articles'; 

const ArticleDetails = () => {
  const { id } = useParams(); 
  const navigate = useNavigate(); 
  const article = cardData.find((a) => a.id === id);

  if (!article) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="h4" color="error">
          Article not found!
        </Typography>
        <Button
          onClick={() => navigate(-1)} 
          sx={{ mt: 2 }}
          variant="contained"
        >
          Back to Articles
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      {/* Title */}
      <Typography variant="h3" sx={{ mb: 2, fontWeight: 'bold', color: article.bgColor }}>
        {article.title}
      </Typography>

      {/* Image */}
      {article.img && (
        <CardMedia
          component="img"
          src={article.img}
          alt={article.title}
          sx={{ width: '100%', height: 400, borderRadius: 2, objectFit: 'cover', mb: 3 }}
        />
      )}

      {/* Full Content */}
      <Box sx={{ lineHeight: 1.8 }}>
        <Typography variant="body1" color="text.primary" paragraph>
          {article.fullContent.split('\n').map((paragraph, index) => (
            <span key={index}>
              {paragraph.trim() ? <p>{paragraph}</p> : <br />}
            </span>
          ))}
        </Typography>
      </Box>

      {/* Back Button */}
      <Box sx={{ mt: 4 }}>
        <Button
          onClick={() => navigate(-1)} // Go back
          sx={{ color: article.bgColor }}
        >
          ← Back to Articles
        </Button>
      </Box>
    </Container>
  );
};

export default ArticleDetails;
